import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import DataService from '../../../../services/MisDatosService';
import { useAuthStore as useAuthStoreEroski } from '../../../../store/AuthContext';
import useAPIError from '../../../../hooks/useAPIError';
import IconBack from '../../../../Icons/IconBack';
import IconChat from '../../../../Icons/IconChat';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

// const TarjetaForm: FC<Props> = (props) => {
const TarjetaForm: FC<Props> = (Props) => {
  const { visible, setVisible } = Props;
  const dataUser = useAuthStoreEroski();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { addError, addErrorBack } = useAPIError();

  const [load, setLoad] = useState<boolean>(false);

  const hide = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    setVisible(false);
    document.body.classList.remove('fix');
  };

  useEffect(() => {
    // if (dataUser.user.token !== '')
    setLoad(true);
  }, [dataUser.user.token]);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('solicitar-btn').click();
    }
  };
  useEffect(() => {
    if (visible && load) {
      const element = document.querySelector(
        'section.o-section--large.form-solicitar.bloque-form.visible',
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else {
      const element = document.querySelector(
        'section.o-section--large.form-solicitar.bloque-form',
      ) as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
    }
  }, [visible, load]);

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <section
                className={`o-section--large form-solicitar bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a className="link-prev" onClick={() => hide()}>
                    <div className="icon icon-medium">
                      <IconBack />
                    </div>
                    <p className="u-font-normal u-text-brand u-margin-left">
                      Volver
                    </p>
                  </a>

                  <form id="form-datos" noValidate className="form-datos-list">
                    <fieldset>
                      <h2 className="bloque-datos__title u-text-brand">
                        <span className="divider__square brand-color" />
                        <span className="u-margin-right">
                          Solicitud de tarjeta adicional
                        </span>
                      </h2>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              Nombre
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="nombre"
                                id="nombre"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un nombre"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="primerapellido"
                              className="control-label"
                            >
                              Primer apellido
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="primerapellido"
                                id="primerapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el primer apellido"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="segundoapellido"
                              className="control-label"
                            >
                              Segundo apellido
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="segundoapellido"
                                id="segundoapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el segundo apellido"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              Tarjeta Cliente
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="num-tarjeta"
                                id="num-tarjeta"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un número de tarjeta"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="dni" className="control-label">
                              Documento de identidad
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label className="hidden" htmlFor="tipo-dni">
                                  Tipo de documento
                                </label>
                                <select
                                  className="form-control select-dni"
                                  id="tipo-dni"
                                >
                                  <option value="nif">NIF</option>
                                  <option value="nie">NIE</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="nif"
                                  id="dni"
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un documento de identidad"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3>Direccion habitual</h3>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              Nombre de la via
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="nombre"
                                id="nombre"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un nombre"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              className="control-label"
                              htmlFor="localidad-entrega"
                            >
                              Localidad
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              disabled
                              id="localidad-entrega"
                              placeholder="Madrid"
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="cod-entrega"
                              className="control-label"
                            >
                              Código postal
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="cod-entrega"
                                id="cod-entrega"
                                maxLength={5}
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un código postal"
                                data-rule-minlength="5"
                                data-msg-minlength="Por favor introduce un código postal correcto"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="num-entrega"
                              className="control-label"
                            >
                              Número
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="num-entrega"
                                id="num-entrega"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un número"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="portal-entrega"
                              className="control-label"
                            >
                              Portal
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                id="portal-entrega"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="escalera-entrega"
                              className="control-label"
                            >
                              Escalera
                            </label>
                            <div className="form-control-block" />
                            <input
                              type="text"
                              className="form-control"
                              id="escalera-entrega"
                            />
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="piso-entrega"
                              className="control-label"
                            >
                              Piso
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                id="piso-entrega"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-4 col-md-1">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="puerta-entrega"
                              className="control-label"
                            >
                              Puerta
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                id="puerta-entrega"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3>Datos de contacto</h3>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono"
                              className="control-label"
                            >
                              Teléfono móvil
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pais-telefono"
                                  id="pais-telefono"
                                  maxLength={15}
                                  value="+34 "
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un Teléfono"
                                  data-rule-minlength="9"
                                  data-msg-minlength="Por favor introduce un teléfono correcto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono-secundario"
                              className="control-label"
                            >
                              Teléfono secundario
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono-secundario"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className="form-control u-margin-left"
                                name="pais-telefono-secundario"
                                id="pais-telefono-secundario"
                                maxLength={15}
                                value="+34 "
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="email" className="control-label">
                              Email de contacto
                            </label>
                            <div className="form-control-block">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                id="email"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un email"
                                data-msg-email="Por favor introduce un email valido"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3>Datos personales tarjeta adicional</h3>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="nombre" className="control-label">
                              Nombre
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="nombre"
                                id="nombre"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un nombre"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="primerapellido"
                              className="control-label"
                            >
                              Primer apellido
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="primerapellido"
                                id="primerapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el primer apellido"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="segundoapellido"
                              className="control-label"
                            >
                              Segundo apellido
                            </label>
                            <div className="form-control-block">
                              <input
                                type="text"
                                className="form-control"
                                name="segundoapellido"
                                id="segundoapellido"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce el segundo apellido"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="nacimiento"
                              className="control-label"
                            >
                              Fecha de nacimiento
                            </label>
                            <div className="form-control-block has-icon datepicker-block">
                              <input
                                className="form-control has-datepicker hasDatepicker"
                                name="nacimiento"
                                id="nacimiento"
                                placeholder="DD/MM/AAAA"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce la fecha"
                                maxLength={10}
                              />
                              <div className="icon icon-medium">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M4.57183333,2.09393162 L4.57183333,3.84692308 L15.1918333,3.84692308 L15.1918333,2.09393162 L16.2335,2.09393162 L16.2335,3.84692308 L18.9968333,3.84692308 C19.40725,3.84692308 19.7414167,4.18965812 19.7414167,4.61059829 L19.7414167,4.61059829 L19.7414167,17.1900855 C19.7414167,17.6110256 19.40725,17.9537607 18.9968333,17.9537607 L18.9968333,17.9537607 L0.744333333,17.9537607 C0.333916667,17.9537607 0.000166666667,17.6110256 0.000166666667,17.1900855 L0.000166666667,17.1900855 L0.000166666667,4.61059829 C0.000166666667,4.18965812 0.333916667,3.84692308 0.744333333,3.84692308 L0.744333333,3.84692308 L3.53016667,3.84692308 L3.53016667,2.09393162 L4.57183333,2.09393162 Z M3.53016667,4.91529915 L1.04183333,4.91529915 L1.04183333,16.8853846 L18.69975,16.8853846 L18.69975,4.91529915 L16.2335,4.91529915 L16.2335,7.00846154 L15.1918333,7.00846154 L15.1918333,4.91529915 L4.57183333,4.91529915 L4.57183333,7.00846154 L3.53016667,7.00846154 L3.53016667,4.91529915 Z M6.40341667,12.7796581 C6.57716667,12.7796581 6.718,12.9219658 6.718,13.1057265 L6.718,13.1057265 L6.718,14.727094 C6.718,14.9065812 6.57383333,15.0518803 6.40341667,15.0518803 L6.40341667,15.0518803 L3.86883333,15.0518803 C3.69508333,15.0518803 3.55383333,14.9104274 3.55383333,14.727094 L3.55383333,14.727094 L3.55383333,13.1057265 C3.55383333,12.925812 3.698,12.7796581 3.86883333,12.7796581 L3.86883333,12.7796581 Z M11.1480833,12.7796581 C11.32225,12.7796581 11.4630833,12.9219658 11.4630833,13.1057265 L11.4630833,13.1057265 L11.4630833,14.727094 C11.4630833,14.9065812 11.3189167,15.0518803 11.1480833,15.0518803 L11.1480833,15.0518803 L8.61391667,15.0518803 C8.43975,15.0518803 8.29933333,14.9104274 8.29933333,14.727094 L8.29933333,14.727094 L8.29933333,13.1057265 C8.29933333,12.925812 8.44308333,12.7796581 8.61391667,12.7796581 L8.61391667,12.7796581 Z M15.8949583,12.7796581 C16.069125,12.7796581 16.2099583,12.9219658 16.2099583,13.1057265 L16.2099583,13.1057265 L16.2099583,14.727094 C16.2099583,14.9065812 16.0657917,15.0518803 15.8949583,15.0518803 L15.8949583,15.0518803 L13.3607917,15.0518803 C13.186625,15.0518803 13.0449583,14.9104274 13.0449583,14.727094 L13.0449583,14.727094 L13.0449583,13.1057265 C13.0449583,12.925812 13.1899583,12.7796581 13.3607917,12.7796581 L13.3607917,12.7796581 Z M6.40341667,9.21123932 C6.57716667,9.21123932 6.718,9.35269231 6.718,9.53602564 L6.718,9.53602564 L6.718,11.1561111 C6.718,11.3355983 6.57383333,11.4817521 6.40341667,11.4817521 L6.40341667,11.4817521 L3.86883333,11.4817521 C3.69508333,11.4817521 3.55383333,11.3398718 3.55383333,11.1561111 L3.55383333,11.1561111 L3.55383333,9.53602564 C3.55383333,9.35653846 3.698,9.21123932 3.86883333,9.21123932 L3.86883333,9.21123932 Z M11.1480833,9.21123932 C11.32225,9.21123932 11.4630833,9.35269231 11.4630833,9.53602564 L11.4630833,9.53602564 L11.4630833,11.1561111 C11.4630833,11.3355983 11.3189167,11.4817521 11.1480833,11.4817521 L11.1480833,11.4817521 L8.61391667,11.4817521 C8.43975,11.4817521 8.29933333,11.3398718 8.29933333,11.1561111 L8.29933333,11.1561111 L8.29933333,9.53602564 C8.29933333,9.35653846 8.44308333,9.21123932 8.61391667,9.21123932 L8.61391667,9.21123932 Z M15.8949583,9.21123932 C16.069125,9.21123932 16.2099583,9.35269231 16.2099583,9.53602564 L16.2099583,9.53602564 L16.2099583,11.1561111 C16.2099583,11.3355983 16.0657917,11.4817521 15.8949583,11.4817521 L15.8949583,11.4817521 L13.3607917,11.4817521 C13.186625,11.4817521 13.0449583,11.3398718 13.0449583,11.1561111 L13.0449583,11.1561111 L13.0449583,9.53602564 C13.0449583,9.35653846 13.1899583,9.21123932 13.3607917,9.21123932 L13.3607917,9.21123932 Z"
                                    transform="translate(0 -2)"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="dni" className="control-label">
                              Documento de identidad
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label className="hidden" htmlFor="tipo-dni">
                                  Tipo de documento
                                </label>
                                <select
                                  className="form-control select-dni"
                                  id="tipo-dni"
                                >
                                  <option value="nif">NIF</option>
                                  <option value="nie">NIE</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="nif"
                                  id="dni"
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un documento de identidad"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <p className="control-label u-margin-bottom">
                            Género
                          </p>

                          <div className="radio radio-inline u-margin-bottom">
                            <input
                              type="radio"
                              name="genero"
                              id="hombre"
                              value="hombre"
                              className="form-control"
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="hombre" className="control-label">
                              Hombre
                            </label>
                          </div>
                          <div className="radio radio-inline">
                            <input
                              type="radio"
                              name="genero"
                              id="mujer"
                              value="mujer"
                              className="form-control"
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="mujer" className="control-label">
                              Mujer
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12">
                          <h3>
                            Datos de contacto (Rellena al menos una de las tres)
                          </h3>
                        </div>
                      </div>
                      <div className="row u-margin-bottom@desktop">
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono"
                              className="control-label"
                            >
                              Teléfono móvil
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <div className="form-control input-select">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pais-telefono"
                                  id="pais-telefono"
                                  maxLength={15}
                                  value="+34 "
                                  data-rule-required="true"
                                  data-msg-required="Por favor introduce un Teléfono"
                                  data-rule-minlength="9"
                                  data-msg-minlength="Por favor introduce un teléfono correcto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor="pais-telefono-secundario"
                              className="control-label"
                            >
                              Teléfono secundario
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono-secundario"
                                >
                                  Selecciona el pais
                                </label>
                                <select className="form-control pais-telefono">
                                  <option value="+34 ">España</option>
                                  <option value="+351 ">Portugal</option>
                                  <option value="+33 ">Francia</option>
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className="form-control u-margin-left"
                                name="pais-telefono-secundario"
                                id="pais-telefono-secundario"
                                maxLength={15}
                                value="+34 "
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="email" className="control-label">
                              Email de contacto
                            </label>
                            <div className="form-control-block">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                id="email"
                                data-rule-required="true"
                                data-msg-required="Por favor introduce un email"
                                data-msg-email="Por favor introduce un email valido"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="checkbox">
                            <label className="checkgroup" htmlFor="no-email">
                              No deseo recibir e-mails
                              <input type="checkbox" id="no-email" />
                              <span className="checkmark" />
                            </label>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="checkbox">
                            <label className="checkgroup" htmlFor="no-sms">
                              {' '}
                              No deseo recibir SMS
                              <input type="checkbox" id="no-sms" />
                              <span className="checkmark" />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="u-margin-bottom-medium">
                        <div className="checkbox">
                          <label
                            className="checkgroup"
                            htmlFor="aceptar-politica"
                          >
                            {' '}
                            Acepto la politica de datos
                            <input type="checkbox" id="aceptar-politica" />
                            <span className="checkmark" />
                          </label>
                        </div>
                      </div>

                      <div className="u-text-right">
                        <button
                          id="solicitar-btn"
                          type="submit"
                          className="btn btn-primary"
                        >
                          Actualizar
                        </button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </section>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default TarjetaForm;
